module.exports = "/images/archive-icon.svg?87af258c038215e1c7fe9e8e40647152";